import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=a00b8718&"
import script from "./MenuItem.vue?vue&type=script&lang=js&"
export * from "./MenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports